import { render, staticRenderFns } from "./DxpPageFeedback.vue?vue&type=template&id=a210894a&scoped=true&"
import script from "./DxpPageFeedback.vue?vue&type=script&lang=js&"
export * from "./DxpPageFeedback.vue?vue&type=script&lang=js&"
import style0 from "./DxpPageFeedback.vue?vue&type=style&index=0&id=a210894a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a210894a",
  null
  
)

export default component.exports